import * as React from 'react';

import styles from './ChatMessageMeta.css';
import { ChatPrettyDate } from '../ChatPrettyDate';
import { TColors } from '@cian/ui-kit-design-tokens/colors';

interface IChatMessageMetaProps {
  created: number;
  statusIcon: React.ReactNode;
  color?: TColors;
}

export const ChatMessageMeta: React.FC<React.PropsWithChildren<IChatMessageMetaProps>> = ({
  created,
  statusIcon,
  color,
}) => {
  return (
    <div className={styles['message__meta']} data-name="ChatMessageLayout_info">
      <ChatPrettyDate date={created} showOnlyTime color={color} />

      {statusIcon && (
        <span className={styles['status-icon']} data-name="ChatMessageLayout_status">
          {statusIcon}
        </span>
      )}
    </div>
  );
};
